import axios from 'axios';
import { ROOT_URL } from '../globals';
import { SHOPPING_LIST_LIST_UPDATE_MEMBER } from './shopping_list_list_actions';

export const FETCH_SL_BEGIN   = 'FETCH_SL_BEGIN';
export const FETCH_SL_SUCCESS = 'FETCH_SL_SUCCESS';
export const FETCH_SL_FAILURE = 'FETCH_SL_FAILURE';

export const SL_MOD_RECIPES_BEGIN   = 'SL_MOD_RECIPES_BEGIN';
export const SL_MOD_RECIPES_SUCCESS = 'SL_MOD_RECIPES_SUCCESS';
export const SL_MOD_RECIPES_FAILURE = 'SL_MOD_RECIPES_FAILURE';

export const SL_ADD_ITEMS_BEGIN   = 'SL_ADD_ITEMS_BEGIN';
export const SL_ADD_ITEMS_SUCCESS = 'SL_ADD_ITEMS_SUCCESS';
export const SL_ADD_ITEMS_FAILURE = 'SL_ADD_ITEMS_FAILURE';

export const SL_UPD_ITEM_BEGIN   = 'SL_UPD_ITEM_BEGIN';
export const SL_UPD_ITEM_SUCCESS = 'SL_UPD_ITEM_SUCCESS';
export const SL_UPD_ITEM_FAILURE = 'SL_UPD_ITEM_FAILURE';

export const SL_ADD_ITEMS_CLEAR_STATUS = 'SL_ADD_ITEMS_CLEAR_STATUS';

export const fetchSLBegin = () => ({
  type: FETCH_SL_BEGIN
});

export const fetchSLSuccess = shopList => ({
  type: FETCH_SL_SUCCESS,
  payload: shopList
});

export const fetchSlFailure = error => ({
  type: FETCH_SL_FAILURE,
  payload: error
});

export const modSLRecipesBegin = () => ({
    type: SL_MOD_RECIPES_BEGIN
  });
  
export const modSLRecipesSuccess = shopList => ({
    type: SL_MOD_RECIPES_SUCCESS,
    payload: shopList
});

export const modSLRecipesFailure = error => ({
    type: SL_MOD_RECIPES_FAILURE,
    payload: { error }
});

export const modSLL = list => ({
    type: SHOPPING_LIST_LIST_UPDATE_MEMBER,
    payload: list
});

export const addSLItemsBegin = () => ({
    type: SL_ADD_ITEMS_BEGIN
  });
  
  export const addSLItemsClearStatus = () => ({
    type: SL_ADD_ITEMS_CLEAR_STATUS
  });

  export const addSLItemsSuccess = shopList => ({
    type: SL_ADD_ITEMS_SUCCESS,
    payload: shopList
});

export const addSLItemsFailure = error => ({
    type: SL_ADD_ITEMS_FAILURE,
    payload: { error }
});

export const updItemBegin = () => ({
    type: SL_UPD_ITEM_BEGIN
  });
  
  export const updItemSuccess = shopList => ({
    type: SL_UPD_ITEM_SUCCESS,
    payload: shopList
  });
  
  export const updItemFailure = error => ({
    type: SL_UPD_ITEM_FAILURE,
    payload: error
  });
  
export function shoppingListAddItems(list, items) {
    return dispatch => {
        const url = `${ROOT_URL}ShoppingLists/AddShoppingListItems`;
        const parms = { acctId: list.Account_Id, listId: list.Shopping_List_Id, items: JSON.stringify(items)};
        dispatch(addSLItemsBegin())
        axios.post(url, parms)
        .then (function(result) {
            if (result.data.StatusCode !== 9999) {
                dispatch(addSLItemsSuccess(result));
                dispatch(modSLL(result));
                return result;
            }
            else {
                dispatch(addSLItemsFailure(result.data.StatusMsg));
            }
        })
        .catch(error => dispatch(addSLItemsFailure(error)));
    }
}

export function shoppingListUpdateNotes(list, notes) {
    return dispatch => {
        const url = `${ROOT_URL}ShoppingLists/UpdateShoppingListNotes`;
        const parms = { acctId: list.Account_Id, listId: list.Shopping_List_Id, notes: notes };
        dispatch(modSLRecipesBegin())
        axios.post(url, parms)
        .then (function(result) {
        dispatch(modSLRecipesSuccess(result));
        dispatch(modSLL(result));
        return result;
        })
        .catch(error => dispatch(modSLRecipesFailure(error)));
    }
};

export function shoppingListUpdateName(list, name) {
    return dispatch => {
        const url = `${ROOT_URL}ShoppingLists/UpdateShoppingListName`;
        const parms = { acctId: list.Account_Id, listId: list.Shopping_List_Id, name: name };
        dispatch(modSLRecipesBegin())
        axios.post(url, parms)
        .then (function(result) {
        dispatch(modSLRecipesSuccess(result));
        dispatch(modSLL(result));
        return result;
        })
        .catch(error => dispatch(modSLRecipesFailure(error)));
    }
};

export function shoppingListAddRecipe(list, recipe) {
    return dispatch => {
        const url = `${ROOT_URL}ShoppingLists/AddShoppingListRecipe`;
        const parms = { acctId: list.Account_Id, listId: list.Shopping_List_Id, recipeId: recipe.Recipe_Id };
        dispatch(modSLRecipesBegin())
        axios.post(url, parms)
        .then (function(result) {
        dispatch(modSLRecipesSuccess(result));
        dispatch(modSLL(result));
        return result;
        })
        .catch(error => dispatch(modSLRecipesFailure(error)));
    }
};

export function shoppingListRemoveRecipe(list, recipe) {
    return dispatch => {
        const url = `${ROOT_URL}ShoppingLists/RemoveShoppingListRecipe`;
        const parms = { acctId: list.Account_Id, listId: list.Shopping_List_Id, recipeId: recipe.Recipe_Id };
        dispatch(modSLRecipesBegin())
        axios.post(url, parms)
        .then (function(result) {
        dispatch(modSLRecipesSuccess(result));
        return result;
        })
        .catch(error => dispatch(modSLRecipesFailure(error)));
    }
};

export function shoppingListUpdateItem(list, item) {
    return dispatch => {
        const url = `${ROOT_URL}ShoppingLists/UpdateShoppingListItem`;
        const parms = { acctId: list.Account_Id, listId: list.Shopping_List_Id, itemId: item.Item_Id,  measureId: item.Measurement_Id, qty: item.Quantity };
        dispatch(updItemBegin())
        axios.post(url, parms)
        .then (function(result) {
        dispatch(updItemSuccess(result));
        return result;
        })
        .catch(error => dispatch(updItemFailure(error)));
    }
};




// WEBPACK FOOTER //
// ./src/actions/shop_list_actions.js